import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../../store';
import type { ImOkDocument, ImOkDocumentSimple, ImOkDocumentState } from './types';
import { tenantScopeReset } from '../../Organizations/OrganizationsSlice/tenantScopeReset';

const initialState: ImOkDocumentState = {
  imOkList: [],
  isLoading: false,
  imOkErrors: null,
  imOkDocument: null,
  showImOkBottomModal: false,
};

const imOkSlice = createSlice({
  name: 'imOkState',
  initialState,
  reducers: {
    setImOkList: (state, action: PayloadAction<ImOkDocument[]>) => {
      state.imOkList = action.payload;
    },
    setImOkLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setImOkDocument: (state, action: PayloadAction<ImOkDocumentSimple | null>) => {
      state.imOkDocument = action.payload;
    },
    setIsError: (state, action: PayloadAction<string>) => {
      state.imOkErrors = action.payload;
    },
    setShowImOkBottomModal: (state, action: PayloadAction<boolean>) => {
      state.showImOkBottomModal = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(tenantScopeReset, () => initialState);
  },
});

export const { setImOkLoading, setIsError, setImOkList, setImOkDocument, setShowImOkBottomModal } =
  imOkSlice.actions;

export const selectImOkList = (state: RootState) => state.imOkState.imOkList;
export const selectImOkDocument = (state: RootState) => state.imOkState.imOkDocument;
export const selectImOkIsLoading = (state: RootState) => state.imOkState.isLoading;
export const isImOkBottomModalOpen = (state: RootState) => state.imOkState.showImOkBottomModal;

export default imOkSlice.reducer;
